import React from 'react'
import AdminError from 'routes/exception/routes/AdminError'
import { Notifier } from '@airbrake/browser'
// import { connect } from 'react-redux'

class ErrorHandler extends React.Component {

    state = {
        hasError: false
    }

    airbrake = new Notifier({
        projectId: 294375,
        projectKey: 'db267c46447ba1afae016a073e1f3526',
        environment: 'production'
    })

    componentDidCatch(error, info) {
        // const { user } = this.props

        const errorLog = {
            error,
            params: { info }
        }

        // Display fallback UI
        this.setState({
            hasError: true,
        })

        if(process.env.NODE_ENV === 'production'){
            this.airbrake.notify(errorLog)
        }

    }

    render() {

        const { hasError } = this.state

        if (hasError) {
            return <AdminError />
        }
        return this.props.children
    }
}

// const mapStateToProps = (state) => {
//     return {
//         user: state.user
//     }
// }

export default ErrorHandler